export default __webpack_public_path__ + "2653146f4d1b5d82095ba876fb3b23f0.png";